import React, { useEffect, useState } from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../../Layout/GRISidebar";
import styles from "../../../../styles/gri/general.module.css";
import { Box, Button } from "@mui/material";
import DynamicTable from "../../../../Components/Common/DynamicTable";
import EastIcon from "@mui/icons-material/East";
import { restructureData } from "../../../../utils/restructureData";
import {
  validateLeadershipTable,
  validateOptionalTable,
} from "../../../../utils/validateTable";
import { useNavigate, useParams } from "react-router-dom";
import MessagePopup from "../../../../Components/Masters/MessagePopup";
import { get, put } from "../../../../utils/api";
import FixedTable from "../../../../Components/Common/FixedTable";

import ReviewBox from "../../../../Components/Common/ReviewBox";
import { currentYear } from "../../../../utils/generateYearRanges";

const GRI207_4 = ({ hide, downloadMode = false }) => {
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [tableLength, setTableLength] = useState(1);
   const [griReview, setGriReview] = useState(() => JSON.parse(localStorage.getItem("griReview")));
 const inputData = [
    {
      fieldName: "taxJurisdictionsList",
      title:
        "a. Provide the list of all tax jurisdictions where the entities included in the organization’s audited consolidated financial statements or filed financial information are resident for tax purposes.",
      type: "array",
      fields: [
        {
          fieldName: "tax",
          title: "Tax Jurisdictions",
          type: "text",
          placeholder: "Enter Text",
          width: "82%",
        },
      ],
    },
  ];

  const tableData = [
    // i
    [
      {
        fieldName: "residentEntitiesNames",
        title:
          "Provide the names of the resident entities, specifying if any are dormant.",
        type: "array",
        letter: "i.",
        fields: [
          {
            fieldName: "tax",
            title: "Tax Jurisdictions",
            type: "text",
            placeholder: "Enter Text",
            width: "31%",
          },
          {
            fieldName: "resident",
            title: "Resident Entities",
            type: "text",
            placeholder: "Enter Text",
            width: "31%",
          },
          {
            fieldName: "dormant",
            title: "Dormant Entities",
            type: "text",
            placeholder: "Enter Text",
            width: "30%",
          },
        ],
      },
    ],
    // ii
    [
      {
        fieldName: "primaryActivitiesByTaxJurisdiction",
        title:
          "Describe the primary activities of the organization within each tax jurisdiction.",
        type: "array",
        letter: "ii.",
        fields: [
          {
            fieldName: "tax",
            title: "Tax Jurisdictions",
            type: "text",
            placeholder: "Enter Text",
            width: "47%",
          },
          {
            fieldName: "primaryAcitity",
            title: "Primary Activities",
            type: "text",
            placeholder: "Enter Text",
            width: "45%",
          },
        ],
      },
    ],
    // iii
    [
      {
        fieldName: "employeeCountByJurisdiction",
        title:
          "Report the number of employees, indicating the basis of calculation (e.g., headcount or full-time equivalent) and ensuring consistency across all jurisdictions.",
        type: "array",
        letter: "iii.",
        fields: [
          {
            fieldName: "tax",
            title: "Tax Jurisdictions",
            type: "text",
            placeholder: "Enter Text",
            width: "23%",
          },
          {
            fieldName: "numberOfEmployee",
            title: "Number of Employees",
            type: "number",
            placeholder: "Enter Number",
            width: "23%",
          },
          {
            fieldName: "basiCalculation",
            title: "Basis of Calculation",
            type: "text",
            placeholder: "Enter Text",
            width: "23%",
          },
          {
            fieldName: "consistency",
            title: "Consistency across Jurisdictions",
            type: "text",
            placeholder: "Enter Text",
            width: "23%",
          },
        ],
      },
    ],
    // iv
    [
      {
        fieldName: "thirdPartyRevenueByJurisdiction",
        title:
          "Disclose revenues from third-party sales for each tax jurisdiction.",
        type: "array",
        letter: "iv.",
        fields: [
          {
            fieldName: "tax",
            title: "Tax Jurisdictions",
            type: "text",
            placeholder: "Enter Text",
            width: "47%",
          },
          {
            fieldName: "revenue",
            title: "Revenues from Third-Party Sales (Currency)",
            type: "text",
            placeholder: "Enter Text",
            width: "45%",
          },
        ],
      },
    ],
    // v.
    [
      {
        fieldName: "intraGroupRevenueByJurisdiction",
        title:
          "Detail revenues from intra-group transactions with other tax jurisdictions, specifying transactions within and outside the jurisdiction.",
        type: "array",
        letter: "v.",
        fields: [
          {
            fieldName: "tax",
            title: "Tax Jurisdictions",
            type: "text",
            placeholder: "Enter Text",
            width: "30%",
          },
          {
            fieldName: "jurisdiction",
            title:
              "Revenues from Intra-Group Transactions within the Jurisdiction",
            type: "text",
            placeholder: "Enter Text",
            width: "31%",
          },
          {
            fieldName: "jurisdictionOutside",
            title:
              "Revenues from Intra-Group Transactions outside the Jurisdiction",
            type: "text",
            placeholder: "Enter Text",
            width: "31%",
          },
        ],
      },
    ],
    // vi
    [
      {
        fieldName: "preTaxProfitLossByJurisdiction",
        title: "State the profit/loss before tax for each tax jurisdiction.",
        type: "array",
        letter: "vi.",
        fields: [
          {
            fieldName: "tax",
            title: "Tax Jurisdictions",
            type: "text",
            placeholder: "Enter Text",
            width: "47%",
          },
          {
            fieldName: "beforeTax",
            title: "Profit/Loss Before Tax",
            type: "text",
            placeholder: "Enter Text",
            width: "45%",
          },
        ],
      },
    ],
    // vii
    [
      {
        fieldName: "tangibleAssetsByTaxJurisdiction",
        title:
          "Specify the total tangible assets other than cash and cash equivalents held within each tax jurisdiction.",
        type: "array",
        letter: "vii.",
        fields: [
          {
            fieldName: "tax",
            title: "Tax Jurisdictions",
            type: "text",
            placeholder: "Enter Text",
            width: "47%",
          },
          {
            fieldName: "total",
            title:
              "Total Tangible Assets (excluding cash and cash equivalents)",
            type: "text",
            placeholder: "Enter Text",
            width: "45%",
          },
        ],
      },
    ],
    // viii
    [
      {
        fieldName: "cashBasisCorporateIncomeTaxPaid",
        title:
          " Report corporate income tax paid on a cash basis, including taxes withheld and paid on behalf of employees.",
        type: "array",
        letter: "viii.",
        fields: [
          {
            fieldName: "tax",
            title: "Tax Jurisdictions",
            type: "text",
            placeholder: "Enter Text",
            width: "47%",
          },
          {
            fieldName: "taxPaid",
            title: "Corporate Income Tax Paid (Cash Basis)",
            type: "text",
            placeholder: "Enter Text",
            width: "45%",
          },
        ],
      },
    ],
    // ix
    [
      {
        fieldName: "accruedCorporateIncomeTax",
        title:
          "Provide the corporate income tax accrued on profit/loss for each tax jurisdiction.",
        type: "array",
        letter: "ix.",
        fields: [
          {
            fieldName: "tax",
            title: "Tax Jurisdictions",
            type: "text",
            placeholder: "Enter Text",
            width: "47%",
          },
          {
            fieldName: "incomeTax",
            title: "Corporate Income Tax Accrued on Profit / Loss",
            type: "text",
            placeholder: "Enter Text",
            width: "45%",
          },
        ],
      },
    ],
    // x
    [
      {
        fieldName: "taxRateVarianceExplanation",
        title:
          "Explain the reasons for any difference between the accrued corporate income tax on profit/loss and the tax due if the statutory tax rate is applied.",
        type: "array",
        letter: "x.",
        fields: [
          {
            fieldName: "tax",
            title: "Tax Jurisdictions",
            type: "text",
            placeholder: "Enter Text",
            width: "47%",
          },
          {
            fieldName: "reason",
            title: "Reason for Difference",
            type: "text",
            placeholder: "Enter Text",
            width: "45%",
          },
        ],
      },
    ],
    // c
    [
      {
        fieldName: "disclosureReportingPeriod",
        title:
          "Indicate the time period covered by the information reported in Disclosure 207-4, ensuring alignment with financial reporting and explaining any deviations from the reporting period.",
        type: "array",
        letter: "c.",
        fields: [
          {
            fieldName: "tax",
            title: "Tax Jurisdictions",
            type: "text",
            placeholder: "Enter Text",
            width: "30%",
          },
          {
            fieldName: "financialReporting",
            title: "Alignment with Financial Reporting",
            type: "text",
            placeholder: "Enter Text",
            width: "31%",
          },
          {
            fieldName: "deviation",
            title: "Explaination of deviation",
            type: "text",
            placeholder: "Enter Text",
            width: "31%",
          },
        ],
      },
    ],
  ];

  const [tabErrors, setTabErrors] = useState({});
  const [errors, setErrors] = useState({
    residentEntitiesNames: [],
    primaryActivitiesByTaxJurisdiction: {},
    employeeCountByJurisdiction: {},
    thirdPartyRevenueByJurisdiction: {},
    intraGroupRevenueByJurisdiction: {},
    preTaxProfitLossByJurisdiction: {},
    tangibleAssetsByTaxJurisdiction: {},
    cashBasisCorporateIncomeTaxPaid: {},
    accruedCorporateIncomeTax: {},
    taxRateVarianceExplanation: {},
    disclosureReportingPeriod: {},
  });

  const [tables, setTables] = useState([]);
  const [multiTable, setMultiTable] = useState({
    residentEntitiesNames: [],
    primaryActivitiesByTaxJurisdiction: [],
    employeeCountByJurisdiction: [],
    thirdPartyRevenueByJurisdiction: [],
    intraGroupRevenueByJurisdiction: [],
    preTaxProfitLossByJurisdiction: [],
    tangibleAssetsByTaxJurisdiction: [],
    cashBasisCorporateIncomeTaxPaid: [],
    accruedCorporateIncomeTax: [],
    taxRateVarianceExplanation: [],
    disclosureReportingPeriod: [],
  });
  const navigate = useNavigate();
  const [data, setData] = useState({});
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    setTableLength(tables?.[0]?.rows?.length);
  }, [tables]);

  const fetchData = async () => {
    try {
      const res = await get(`/gri/get?Id=${id}&type=GRI200`);
      const res1 = res?.data?.data?.GRI200?.countryReporting;
      if (res?.data?.data?.year ? res?.data?.data?.year < currentYear : false)
        setDisabled(true);
      setData(res1);
    } catch (err) {
      console.log(err);
    }
  };

  const handleSubmit = async () => {
    if (!disabled) {
      let v1 = validateOptionalTable(inputData, tables, setTabErrors);
      let err = tableData?.map((tabData) =>
        validateLeadershipTable(
          tabData,
          multiTable?.[tabData[0]?.fieldName],
          setErrors,
          tabData[0]?.fieldName
        )
      );

      if (err?.includes(false) || !v1) return;

      let transformedData = {
        countryReporting: {
          ...tableData?.reduce((acc, el) => {
            return {
              ...acc,
              ...restructureData(multiTable?.[el[0]?.fieldName]),
            };
          }, {}),
          ...restructureData(tables),
        },
        type: "GRI200",
        submitted207_4: true,
      };

      try {
        const res = await put(`/gri/update?Id=${id}`, {
          type: "GRI200",
          ...transformedData,
        });
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        navigate(`/gri/gri300/301-1/${id}`);
      } catch (error) {
        console.log(error);
        setsnackOpen({
          open: true,
          message: error.data.message,
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/gri300/301-1/${id}`);
    }
  };

  const renderContent = ({ hide }) => (
    <>
      <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
      {!hide && <p className={styles.section_heading}>207 : Tax 2019</p>}
      <p
        className={styles.main_heading}
        style={{ marginBottom: hide ? "-2rem" : "2rem" }}
      >
        207-4 : Country-by-country reporting
      </p>
      <DynamicTable
        {...{
          subHeading: "",
          inputData,
          tables,
          setTables,
          errors: tabErrors,
          disabled: disabled,
          setErrors: setTabErrors,
          data,
          hide,
        }}
      />
      <p
        className={styles.ques_heading}
        style={{
          textDecoration: "none",
          marginBottom: hide ? "-2rem" : "-0.5rem",
        }}
      >
        b. For each tax jurisdiction listed in (a):
      </p>
      {tableData?.map((tabData, index) => {
        // console.log("tab",tabData,index,multiTable?.[tabData[0]?.fieldName])
        return (
          <FixedTable
            {...{
              inputData: tabData,
              fieldName: tabData[0]?.fieldName,
              tables: multiTable?.[tabData[0]?.fieldName],
              setTables: setMultiTable,
              errors: errors?.[tabData[0]?.fieldName],
              setErrors,
              disabled: disabled,
              data,
              tableLength,
            }}
          />
        );
      })}
    </>
  );

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  onClick={handleSubmit}
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default GRI207_4;
